<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <!-- <layout-header2></layout-header2> -->
          <layout-header></layout-header>
          <breadcrumb45></breadcrumb45>

          <!-- Page Content -->
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                  <sidebar></sidebar>
                </div>

                <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                  <loader></loader>
                </div>

                <div class="col-md-7 col-lg-8 col-xl-9 doctor-profile" v-else>
                  <i class="fa fa-arrow-left fa-lg ml-md-4" aria-hidden="true"
                    style="background-color:black; color:white;padding:10px;border-radius:100%; cursor: pointer;"
                    @click="goBack"></i>
                  <!-- Basic Information -->
                  <div class="card mt-2 ml-md-4">
                    <div class="card-body doctor-profile">
                      <div class="add-more text-right">
                        <a href="javascript:void(0);" class="add-reg" data-toggle="modal" data-target="#addExcercise"
                          @click="open_treament('Exercise')"><i class="fa fa-plus-circle"></i> Add Exercise
                        </a>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Exercise Plan Template Name</label>
                            <input type="text" class="form-control" v-model="new_excercise_plan_template.plan_name"
                              placeholder="Template Plan Name"
                              oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');" />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Joint</label>
                            <v-select placeholder="Select Joint" v-model="new_excercise_plan_template.body_part"
                              :options="body_parts" @change="onChange">
                            </v-select>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Therapy Type</label>
                            <v-select placeholder="Plan For" v-model="new_excercise_plan_template.therapyType"
                              v-model.lazy="Therapy_type_controller" :options="all_category">
                            </v-select>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Description</label>
                            <input type="text" class="form-control" v-model="new_excercise_plan_template.description"
                              placeholder="Description" oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');" />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="submit-section text-left">
                            <button @click="get_exercise_plans()" class="btn btn-primary btn-sm mb-1">
                              Get Exercise
                            </button>
                            <hr />
                          </div>
                        </div>
                        <div></div>
                        <div class="col-md-12">
                          <table v-if="final_exercises.length > 0">
                            <tr>
                              <th class="text-left" style="background-color: #F8F8F8;">Exercise Name</th>
                              <th class="text-left" style="background-color: #F8F8F8;">Therapy Type</th>
                              <th class="text-left" style="background-color: #F8F8F8;">Repetition</th>
                              <th class="text-left" style="background-color: #F8F8F8;">Frequency</th>
                              <th class="text-left" style="background-color: #F8F8F8;">Days</th>
                              <th class="text-left" style="background-color: #F8F8F8;">Remove</th>
                            </tr>
                            <tr v-for="ex in final_exercises">
                              <td>{{ ex.exercise_name }}</td>
                              <td>{{ ex.difficulty_level }}</td>
                              <td>{{ ex.repetition_per_session }}</td>
                              <td>{{ ex.frequency_per_day }}</td>
                              <td>{{ ex.no_of_days }}</td>
                              <td>
                                <a href="javascript:void(0);" class="add-reg" @click="remove_Ex_to_arr(ex)"><i
                                    class="fa fa-minus-circle"></i>
                                </a>
                              </td>
                            </tr>
                          </table>
                        </div>
                        <div class="col-md-12" v-if="final_exercises.length > 0">
                          <hr />

                          <div class="submit-section text-left">
                            <button @click="add_new_excercise_plan()" class="col-md-12 btn btn-primary btn-sm mb-1">
                              Add Exercise Plan
                            </button>
                            <hr />
                          </div>
                        </div>

                        <div class="col-md-12"></div>
                        <div class="col-md-12">
                          <table v-if="all_exercises.length > 0">
                            <tr>
                              <th class="text-left" style="background-color: #F8F8F8;">Exercise Name</th>
                              <th class="text-left" style="background-color: #F8F8F8;">Therapy Type</th>
                              <th class="text-left" style="background-color: #F8F8F8;">Video</th>
                              <th class="text-left" style="background-color: #F8F8F8;">Repetition</th>
                              <th class="text-left" style="background-color: #F8F8F8;">Frequency</th>
                              <th class="text-left" style="background-color: #F8F8F8;">Days</th>
                              <th class="text-left" style="background-color: #F8F8F8;">Add</th>
                            </tr>
                            <tr v-for="item in all_exercises">
                              <td>{{ item.exercise_name }}</td>
                              <td>{{ item.difficulty_level }}</td>
                              <td class="text-align: center;">
                                <a href="javascript:void(0);" class="add-reg" data-toggle="modal" data-target="#PlayVideo"
                                  @click="open_Video(item.youtube_url)"><img class="youtube-icon"
                                    src="@/assets/img/Youtube-icon.svg" alt="Video" />
                                </a>
                              </td>
                              <td>
                                <input type="text" class="add-reg" v-model="item.repetition_per_session"
                                  placeholder="Count" />
                              </td>
                              <td>
                                <input type="text" class="add-reg" v-model="item.frequency_per_day"
                                  placeholder="Session" />
                              </td>
                              <td>
                                <input type="text" class="add-reg" v-model="item.no_of_days" placeholder="Days" />
                              </td>
                              <td>
                                <a class="text-align: center;" href="javascript:void(0);" @click="
                                  Add_Ex_to_arr([
                                    item.name,
                                    item.repetition_per_session,
                                    item.frequency_per_day,
                                    item.no_of_days,
                                  ])
                                  "><i class="fa fa-plus-circle"></i>
                                </a>
                              </td>
                            </tr>
                          </table>
                          <!-- Experiment -->
                          <!-- <vue-table :data="list" :columns="columns" :select_event="event"></vue-table> -->
                          <!-- Experiment -->
                        </div>
                        <span></span>
                        <div class="col-md-12"></div>
                        <!-- Excercise Table -->
                        <div class="col-md-6 offset-md-6">
                          <div class="col-md-12"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /Basic Information -->
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <layout-footer></layout-footer>
        </div>
      </div>

      <!-- <div class="modal fade custom-modal show" id="addtemplate"> -->
      <div class="modal fade custom-modal show" id="addExcercise">
        <div class="modal-dialog modal-dialog-centered modal-md">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Exercise</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                  aria-hidden="true">×</span></button>
            </div>
            <div class="modal-body doctor-profile">
              <div class="card">
                <div class="card-body">
                  <div class="row form-row">
                    <div class="col-12 col-md-12">
                      <div class="form-group">
                        <label>Exercise Name</label>
                        <input v-model="add_Excercise.exercise_name" type="text" class="form-control"
                          placeholder="Exercise Plan" value=""
                          oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');" />
                      </div>
                    </div>

                    <div class="col-12 col-md-12">
                      <div class="form-group">
                        <label>Difficulty Level</label>
                        <v-select class="mr-2" required="true" v-model="add_Excercise.difficulty_level"
                          placeholder="Select Category" :options="all_category">
                        </v-select>
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="form-group testimonial">
                        <label>Description</label>
                        <ckeditor :editor="editor" v-model="add_Excercise.description" placeholder="Description ">
                        </ckeditor>
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="form-group">
                        <label>Exercise Video Url </label>
                        <input v-model="add_Excercise.youtube_url" type="url" class="form-control" value=""
                          placeholder="Exercise Video Url " />
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="form-group">
                        <label>Joint</label>
                        <v-select class="mr-2" required="true" v-model="add_Excercise.body_part"
                          placeholder="Select Category" :options="body_parts">
                        </v-select>
                      </div>
                    </div>
                  </div>
                  <div class="submit-section" style="text-align:left">
                    <button @click="add_new_exercise()" class="btn btn-primary submit-btn" data-dismiss="modal"
                      aria-label="Close" :disabled="isAddButtonDisabled">
                      Add Exercise
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade custom-modal show" id="PlayVideo">
        <div class="modal-dialog modal-dialog-centered modal-md">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Play Video</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times fa-sm"
                  aria-hidden="true"></i></button>
            </div>
            <div class="modal-body doctor-profile" style="width:100%; height:100%;">
              <div class="card">
                <div class="card-body">
                  <div class="row form-row">
                    <div class="col-12 col-md-12">
                      <iframe class="col-12 col-md-12" :src="this.open_Videos.url"
                        title="Indian Predator: The Butcher of Delhi | Official Trailer | Netflix India" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// data form
import "vue-table-form/lib/style.css";
import VueTable from "vue-table-form";
// data form

import CommonApi from "../../../services/CommonApi";
import { mapState } from "vuex";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  components: {
    ckeditor: CKEditor.component,
    VueTable,
  },
  data() {
    return {
      //
      showspinner: false,
      disabled_template_button: true,
      disabled_new_template_button: true,
      editor: ClassicEditor,
      all_investigation_template: [],
      all_prescription_template: [],
      all_surgery_template: [],
      all_general_advice_template: [],
      all_exercise_advice_template: [],
      all_exercises: [],
      final_exercises: [],
      check_row: [],
      repetition_per_session: [],
      no_of_days: [],
      frequency_per_day: [],
      Session: [],

      new_excercise_plan_template: {
        plan_name: "",
        practitioner: this.user_id,
        description: "",
        checkboxVal: [],
      },

      add_templates: {
        category: "",
        template_name: "",
        description: "",
        doctor: this.user_id,
      },

      open_Videos: {
        url: "",
      },

      booleanValue: [],

      add_Excercise: {
        exercise_name: "",
        difficulty_level: "",
        description: "",
        practitioner: this.user_id,
        youtube_url: "",
        body_part: "",
      },
      all_category: ["Flexibility", "Range Of Motion", "Strengthening"],
      // post_data:[],

      body_parts: [
        "Knee",
        "Hip",
        "Ankle",
        "Foot",
        "Cervical Spine",
        "Lumbar Spine",
        "Shoulder",
        "Elbow",
        "Forearm",
        "Wrist",
        "Finger"
      ],

      Therapy_type_controller: "",
    };
  },
  computed: {

    isAddButtonDisabled() {
      // Check if any of the fields in add_Excercise are empty
      for (const key in this.add_Excercise) {
        if (this.add_Excercise[key] === "") {
          return true; // Disable the button if any field is empty
        }
      }
      return false; // Enable the button if all fields have values
    },

    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
    template_validation() { },
    new_template_validation() { },
  },
  watch: {
    Therapy_type_controller(value) {
      console.log("Therapy_type_controller", value);

      this.all_exercises = [];

      this.new_excercise_plan_template.practitioner = this.user_id;

      console.log("get_exercise_plans", this.new_excercise_plan_template);

      let data = {
        body_part: this.new_excercise_plan_template.body_part,
        practitioner: this.new_excercise_plan_template.practitioner,
        therapy: value,
      };

      console.log(data);
      CommonApi.post_data(
        "sahaj.v1.physio.get_exercise_by_joint_and_therapy",
        JSON.stringify(data)
      ).then((res) => {
        if (res) {
          for (let j = 0; j < res.data.length; j++) {
            console.log("res.data", res.data[j]);
            this.all_exercises.push({
              name: res.data[j].name,
              exercise_name: res.data[j].exercise_name,
              difficulty_level: res.data[j].difficulty_level,
              doctor_name: res.data[j].doctor_name,
              doctor: res.data[j].doctor,
              description: res.data[j].description,
              youtube_url: res.data[j].youtube_url,
              body_parts: res.data[j].body_parts,
              repetition_per_session: res.data[j].repetition_per_session,
              frequency_per_day: res.data[j].frequency_per_day,
              no_of_days: res.data[j].no_of_days,
            });

            this.repetition_per_session.push({
              repetition_per_session: res.data[j].repetition_per_session,
            }),
              this.no_of_days.push({ no_of_days: res.data[j].no_of_days });
            this.frequency_per_day.push({
              frequency_per_day: res.data[j].frequency_per_day,
            });
          }
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },

    template_validation() { },

    new_template_validation() { },
  },
  methods: {

    goBack() {
      // Go one page back
      this.$router.go(-1);
    },
    event(selects) {
      console.log(selects);
    },

    async remove_Ex_to_arr(rex) {
      const fruits = this.final_exercises;
      let index = fruits.indexOf(rex);
      console.log("index", index);

      this.final_exercises.splice(index, 1);
    },

    async Add_Ex_to_arr(ex) {
      let obj = this.all_exercises.find((o) => o.name === ex[0]);
      this.final_exercises.push(obj);
      // console.log("this.final_exercises",this.final_exercises)
    },
    //
    // Get All Excercises
    async get_therapy_template_plan_dr() {
      const params = new URLSearchParams();

      params.append("practitioner", this.user_id);
      await CommonApi.get_data(
        "sahaj.v1.physio.get_therapy_template_plan_dr",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          // console.log("get_therapy_template_plan_dr",res.data,this.user_id);
          this.all_investigation_template = res.data;
        }
      });
    },

    check: function (e) {
      if (e.target.checked) {
        console.log(e.target.value);
      }
    },
    //data table
    async add_row_ex_template(e) {
      console.log(e.target.value);
    },

    async open_Video(video) {
      console.log("this.Video", video);
      this.open_Videos.url = video;
    },

    //

    async onChange(event) {
      console.log(event);
    },

    /* Get All Template Category  */
    async get_template_category() {
      await CommonApi.get_data("sahaj.template.get_template_category").then(
        (res) => {
          this.showspinner = false;
          if (res && res.message) {
            this.all_category = res.message;
          }
        }
      );
    },

    //Get Exercise Plans
    async get_exercise_plans() {
      this.new_excercise_plan_template.practitioner = this.user_id;

      console.log("get_exercise_plans", this.new_excercise_plan_template);

      let data = {
        body_part: this.new_excercise_plan_template.body_part,
        practitioner: this.new_excercise_plan_template.practitioner,
        therapy: this.new_excercise_plan_template.therapyType,
      };

      console.log(data);
      CommonApi.post_data(
        "sahaj.v1.physio.get_exercise_by_joint_and_therapy",
        JSON.stringify(data)
      ).then((res) => {
        if (res) {
          for (let j = 0; j < res.data.length; j++) {
            console.log("res.data", res.data[j]);
            this.all_exercises.push({
              name: res.data[j].name,
              exercise_name: res.data[j].exercise_name,
              difficulty_level: res.data[j].difficulty_level,
              doctor_name: res.data[j].doctor_name,
              doctor: res.data[j].doctor,
              description: res.data[j].description,
              youtube_url: res.data[j].youtube_url,
              body_parts: res.data[j].body_parts,
              repetition_per_session: res.data[j].repetition_per_session,
              frequency_per_day: res.data[j].frequency_per_day,
              no_of_days: res.data[j].no_of_days,
            });

            this.repetition_per_session.push({
              repetition_per_session: res.data[j].repetition_per_session,
            }),
              this.no_of_days.push({ no_of_days: res.data[j].no_of_days });
            this.frequency_per_day.push({
              frequency_per_day: res.data[j].frequency_per_day,
            });
          }
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },

    open_treament(type) {
      if (type === "Prescription") {
        this.add_templates.category = this.all_category[1];
      } else if (type === "Exercise") {
        this.add_Excercise.difficulty_level = "Strengthening";

        // this.body_parts.body_parts = {"body_part": "Shoulder"};
      } else if (type === "General") {
        this.add_templates.category = this.all_category[3];
      } else if (type === "Surgery") {
        this.add_templates.category = this.all_category[4];
      } else if (type === "Investigation") {
        this.add_templates.category = this.all_category[5];
      }
    },
    // *Add Ned Excercise* /
    // Added by tikam

    async add_new_excercise_plan() {
      console.log(" this.final_exercises", this.final_exercises);

      this.new_excercise_plan_template.checkboxVal = this.final_exercises;
      this.new_excercise_plan_template.practitioner = this.user_id;

      let data_post = {
        plan_name: this.new_excercise_plan_template.plan_name,
        practitioner: this.new_excercise_plan_template.practitioner,
        description: this.new_excercise_plan_template.description,
      };
      let exercises = [];

      for (let i = 0; i < this.final_exercises.length; i++) {
        exercises.push({
          joints: this.final_exercises[i].body_parts[0].body_parts,
          exercise_type: this.final_exercises[i].difficulty_level,
          exercise_name: this.final_exercises[i].name,
          repetition_per_session: this.final_exercises[i]
            .repetition_per_session, //this.check_row[i].repetition_per_session,
          frequency_per_day: this.final_exercises[i].frequency_per_day,
          no_of_days: this.final_exercises[i].no_of_days,
          youtube_url: this.final_exercises[i].youtube_url,
        });
      }

      console.log("exercises", exercises);
      var bodyFormData = new FormData();
      bodyFormData.append("data", JSON.stringify(data_post));
      bodyFormData.append("exercise", JSON.stringify(exercises));

      await CommonApi.post_data(
        "sahaj.v1.physio.add_therapy_plan_template_dr",
        bodyFormData
      ).then((res) => {
        this.showspinner = false;
        if (res && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          });
          this.$emit("close");
          this.$router.push({ path: "/doctor/exercise-plan" });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res,
            showConfirmButton: true,
          });
        }
      });
    },

    async add_new_exercise() {
      console.log("this.add_Excercise", this.add_Excercise);

      let data = {
        description: this.add_Excercise.description,
        difficulty_level: this.add_Excercise.difficulty_level,
        exercise_name: this.add_Excercise.exercise_name,
        practitioner: this.user_id,
        youtube_url: this.add_Excercise.youtube_url,
        joint: this.add_Excercise.body_part,
      };

      CommonApi.post_data(
        "sahaj.v1.physio.add_exercise_type_dr",
        JSON.stringify(data)
      ).then((res) => {
        if (res) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          }).then(() => {
            window.location.reload();
          });
          // this.get_patient_appointment_list_all();
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },

    // code end tikam
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if (!user) {
      this.$router.push({ name: 'login' })
    }
    this.get_therapy_template_plan_dr();
  },
};
</script>
<style scoped>
::placeholder {
  color: red;
  opacity: 1;
  /* Firefox */
}

.vs__search {
  color: #d3d3d3;
}
</style>



// WEBPACK FOOTER //
// src/components/kneexpert/doctor/MyExcersisePlan.vue